export const SECTION_COPY = {
  pickCategory: {
    title: 'Choose a Category',
    description:
      'Browse trips by theme — beaches, adventure, heritage, and more. Select a category to see packages on the map.',
  },
  topDestinations: {
    title: 'Top Destinations',
    description: 'Handpicked getaways our travellers book most often.',
  },
  upcomingEvents: {
    title: 'Upcoming Events around World',
    description:
      'Festivals, fixed departures, and special experiences — see what is coming up next.',
  },
  testimonials: {
    title: 'Testimonials',
    description: 'Stories and feedback from travellers who explored with us.',
  },
  recommendedTours: {
    title: 'You might also like',
    description: 'Similar packages worth exploring on your next trip.',
  },
  contactForm: {
    title: 'Contact Us',
    description:
      'Questions about a package or custom itinerary? Reach out and our team will respond soon.',
  },
};
